import { NamedAttribute } from '@/graphql/__generated/sdk';
import { Maybe } from '@/types';

export const getMatchedAttributesByTitle = (attributes?: Maybe<NamedAttribute[]>, title?: Maybe<string>) => {
	return (
		attributes?.filter(({ name }) => {
			return name?.toLowerCase() === title?.toLowerCase();
		}) || []
	);
};

export const mustExcludeItem = (
	title?: Maybe<string>,
	groupTitle?: Maybe<string>,
	locationAttributes?: Maybe<NamedAttribute[]>
) => {
	const desiredAttributes = getMatchedAttributesByTitle(locationAttributes, groupTitle);
	if (desiredAttributes.length > 0) {
		// dont exclude anything if no matching attributes exist
		return !desiredAttributes.find((attribute) => {
			return attribute.value === title;
		});
	}
	return false;
};
